// removed by extract-text-webpack-plugin
module.exports = {"column":"WhDgzcqvLgaZC2M0SRGPy_0"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?{"sourceMap":true,"localIdentName":"[hash:base64]_0","importLoaders":true,"modules":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6ae5fc33","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["node_modules","src/styles/ui"],"data":"$test: red;","sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Grid/Column.vue
// module id = ROiq
// module chunks = 1